import logotypeStart from './logotype-start.svg'
import logotypeEnd from './logotype-end.svg'

const alignment = {
  s: 'start',
  e: 'end',
}
const classes = {
  [alignment.s]: 'align-start',
  [alignment.e]: 'align-end',
}
const sources = {
  [alignment.s]: logotypeStart,
  [alignment.e]: logotypeEnd,
}
const sanitisedAlign = align =>
  Object.values(alignment).includes(align) ? align : alignment.s

const classesFor = align => {
  const logoClass = classes[sanitisedAlign(align)]
  return `logotype ${logoClass}`
}
const srcFor = align => sources[sanitisedAlign(align)]

export const Logotype = ({align = alignment.s}) => (
  <img
    src={srcFor(align)}
    className={classesFor(align)}
    alt="My Beauty PA logotype"
  />
)
